import { useEffect, useRef, useState } from 'react'
import CoinImage from '../../assets/images/landing-page/pipe-coin.svg'
import './CoinPipe.scss';
const IMG = new Image()
IMG.src = CoinImage

export const COIN_BOTTOM_DIS = 300
let COIN_POSITIONS = undefined

const CoinElement = ({ path, pathWidth, canvasSize }) => {
  const coinCanvasRef = useRef(null)
  const coinTrail1CanvasRef = useRef(null)
  const coinTrail2CanvasRef = useRef(null)

  const [scrollBottomPosition, setScrollBottomPosition] = useState(window.scrollY + window.innerHeight)

  useEffect(() => {
    const getScrollPosition = () => {
      setScrollBottomPosition(Math.round(window.scrollY + window.innerHeight))
    }
    window.addEventListener('scroll', getScrollPosition)
    return () => {
      window.removeEventListener('scroll', getScrollPosition)
    }
  }, [])

  useEffect(() => {
    COIN_POSITIONS = getCoinPositions(path, pathWidth)
  }, [path, pathWidth])

  useEffect(() => {
    if (!COIN_POSITIONS) {
      return
    }

    const coinCurrPosition = getCoinCurrPosition(COIN_POSITIONS, scrollBottomPosition)
    if (!coinCurrPosition) {
      return
    }

    requestAnimationFrame(() => {
      drawCoin(coinCanvasRef, pathWidth, coinCurrPosition)

      setTimeout(() => {
        drawCoin(coinTrail1CanvasRef, pathWidth, coinCurrPosition)
      }, 100)
      setTimeout(() => {
        drawCoin(coinTrail2CanvasRef, pathWidth, coinCurrPosition)
      }, 200)
    })
  }, [pathWidth, scrollBottomPosition])

  return (
    <>
      <canvas className="coin-pipe-canvas trail-2" ref={coinTrail2CanvasRef} {...canvasSize} />
      <canvas className="coin-pipe-canvas trail-1" ref={coinTrail1CanvasRef} {...canvasSize} />
      <canvas className='coin-pipe-canvas' ref={coinCanvasRef} {...canvasSize} />
    </>
  )
}

const getCoinPositions = (path, width) => {
  if (path.length < 2) {
    return
  }
  const halfWidth = Math.round(width / 2)
  const coinPositions = {}

  for (let i = 0; i < path.length - 1; i++) {
    const prevPoint = path[i]
    const nextPoint = path[i + 1]
    const rotate = (prevPoint.y - nextPoint.y) / (prevPoint.x - nextPoint.x)

    // create all the points between two lines
    for (let j = prevPoint.y; j < nextPoint.y; j++) {
      const positionY = j

      const positionX = Math.round(prevPoint.x - (prevPoint.y - positionY) / rotate)

      coinPositions[positionY - halfWidth] = {
        positionX: positionX - halfWidth,
        rotate: rotate > 0 ? rotate - Math.PI : rotate,
      }
    }
  }

  return coinPositions
}

const getCoinCurrPosition = (coinPositions, scrollBottomPosition) => {
  const positionY = scrollBottomPosition - COIN_BOTTOM_DIS
  if (coinPositions[positionY]) {
    return {
      y: positionY,
      x: coinPositions[positionY].positionX,
      rotate: coinPositions[positionY].rotate,
    }
  }
}

const drawCoin = (
  canvasRef,
  pathWidth,
  coinCurrPosition,
) => {
  const canvas = canvasRef.current
  const ctx = canvas?.getContext('2d')
  if (!canvas || !ctx) {
    return
  }
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  ctx.save()
  ctx.translate(coinCurrPosition.x + pathWidth / 2, coinCurrPosition.y + pathWidth / 2)
  ctx.rotate(coinCurrPosition.rotate)
  ctx.translate(-coinCurrPosition.x - pathWidth / 2, -coinCurrPosition.y - pathWidth / 2)
  ctx.drawImage(IMG, coinCurrPosition.x, coinCurrPosition.y, pathWidth / 1.25, pathWidth)
  ctx.restore()
}

export default CoinElement

